export const formattingDetailFn = (type: 'cash' | 'point' | undefined, currencySymbol: string, currencyUnit: string, lng: string) => (value = 0): {
  symbol: string;
  amount: string;
  unit: string | undefined;
} => {
  const count = type === 'cash' ? value / 100 : value;
  return {
    unit: type === 'cash' && currencyUnit ? currencyUnit : '',
    symbol: type === 'cash' ? currencySymbol : '',
    amount: count.toLocaleString(lng + '-u-nu-latn')
  };
};
export const formattingFn = (type: 'cash' | 'point' | undefined, currencySymbol: string, currencyUnit: string, lng: string, needSymbol = true) => (value = 0) => {
  const detail = formattingDetailFn(type, currencySymbol, currencyUnit, lng)(value);

  if (type !== 'cash') {
    return detail.amount;
  }

  if (detail.symbol && needSymbol) {
    return detail.symbol + detail.amount;
  } else {
    return detail.amount + detail.unit;
  }
};